import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import fetchSeatData from '../../../helpers/fetch-seat-data';
// import languageData from "../../../lib/lang.config.json";
import Flutterwave from '../PaymentGateway/Flutterwave';
import NewPayPal from '../PaymentGateway/NewPayPal';
import Paystack from '../PaymentGateway/Paystack';
import Mpesa from '../PaymentGateway/Mpesa';
import Razorpay from '../PaymentGateway/Razorpay';
import SslCommerz from '../PaymentGateway/SslCommerz';
import StripeCheckoutBtn from '../PaymentGateway/StripeCheckoutBtn';
import {
   ButtonWrapper,
   CancelButton,
   Label,
   PaymentAndButton,
   PaymentButton,
   PaymentInput,
   PaymentMethod,
   PaymentUl,
   SinglePayment,
} from './Payment.styles';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';

const Payment = ({
   handleSubmitPayment,
   paymentStutas,
   setPaymentStutas,
   paymentGateway,
   setpaymentGateway,
   passengerInformation,
   allBookingInformation,
   setLoading,
}) => {
   const history = useHistory();
   const { webSettingData } = useSelector((state) => state.busLists);
   const languageData = useSelector((state) => state.busLists.languageData);
   const [paymentMethods, setPaymentMethods] = useState(null);
   const [seatsForBooking, setSeatsForBooking] = useState([]);
   const [date, setDate] = useState();
   const [payPalClientId, setPayPalPaymentId] = useState(null);

   const getPaymentMethods = async () => {
      const response = await fetch(
         `${process.env.REACT_APP_API_MODULE_DOMAIN}/paymethods`
      );

      const result = await response.json();

      if (result?.status === 'success') {
         setPaymentMethods(result?.data);
      }
   };

   const getPaypalData = async () => {
      const response = await fetch(
         `${process.env.REACT_APP_API_MODULE_DOMAIN}/paymethods/paypal`
      );
      const result = await response.json();

      if (result?.status === 'success') {
         setPayPalPaymentId(result?.data?.client_id);
      }
   };

   useEffect(() => {
      try {
         getPaymentMethods();
      } catch (error) {
         console.error('paymentMethods', error);
      }
   }, []);

   useEffect(() => {
      getPaypalData();
   }, []);

   // Automatically select "Pay Now" with Mpesa as default payment method
   useEffect(() => {
      if (!paymentMethods) return;
      if (paymentStutas !== 'Pay Now') {
         setPaymentStutas('Pay Now');
      }
   }, [paymentMethods, paymentStutas, setPaymentStutas]);

   useEffect(() => {
      if (!paymentMethods) return;
      if (paymentGateway) return;

      const mpesaMethod = paymentMethods.find(
         (method) => method?.name === 'mpesa'
      );

      if (mpesaMethod) {
         setpaymentGateway('mpesa');
      }
   }, [paymentMethods, paymentGateway, setpaymentGateway]);

   const handleCancel = () => {
      history.push('/');

      localStorage.removeItem('bookingInfo');
      localStorage.removeItem('searchInfo');
      localStorage.removeItem('returnFirstJourneyInfo');
      localStorage.removeItem('journeyInfo');
      localStorage.removeItem('discount');
      localStorage.removeItem('regular');
      localStorage.removeItem('return');
      localStorage.removeItem('bookingInfoTax');
      localStorage.removeItem('journeyInfoTax');
      localStorage.removeItem('subtripId');
   };

   useEffect(() => {
      const searchInfo = JSON.parse(localStorage.getItem('searchInfo'));
      setDate(searchInfo?.journeydate);

      if (allBookingInformation?.bookingInfo?.seatnumbers) {
         const _convertToArray =
            allBookingInformation?.bookingInfo?.seatnumbers?.split(',');
         setSeatsForBooking(
            _convertToArray.length
               ? _convertToArray
               : [allBookingInformation?.bookingInfo?.seatnumbers]
         );
      }
   }, []);

   const validateEmail = (email) => {
      return String(email)
         .toLowerCase()
         .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
         );
   };

   const validateForm = () => {
      const email = passengerInformation?.login_email || '';
      const mobile = passengerInformation?.login_mobile || '';
      const firstName = passengerInformation?.first_name || '';
      const lastName = passengerInformation?.last_name || '';
      const idNumber = passengerInformation?.id_number || '';

      // Clear previous errors and reset field styles
      const emailError = document.getElementById('email-error');
      const mobileError = document.getElementById('mobile-error');
      const emailField = document.getElementById('email');
      const mobileField = document.getElementById('login_mobile');
      const firstNameField = document.getElementById('name');
      const lastNameField = document.getElementById('surName');
      const idField = document.getElementById('nationalId');
      
      if (emailError) emailError.innerHTML = '';
      if (mobileError) mobileError.innerHTML = '';

      // Reset all field borders and colors
      const allFields = [emailField, mobileField, firstNameField, lastNameField, idField];
      allFields.forEach(field => {
         if (field) {
            field.style.borderColor = '';
            field.style.boxShadow = '';
            field.style.color = '';
         }
      });

      // Check fields in order and focus on first empty field with red border
      if (!email) {
         if (emailField) {
            emailField.focus();
            emailField.style.borderColor = 'red';
            emailField.style.boxShadow = '0 0 0 2px rgba(255, 0, 0, 0.3)';
         }
         return false;
      }

      // Validate email format
      if (!validateEmail(email)) {
         if (emailField) {
            emailField.focus();
            emailField.style.borderColor = 'red';
            emailField.style.boxShadow = '0 0 0 2px rgba(255, 0, 0, 0.3)';
         }
         return false;
      }

      if (!mobile) {
         if (mobileField) {
            mobileField.focus();
            mobileField.style.borderColor = 'red';
            mobileField.style.boxShadow = '0 0 0 2px rgba(255, 0, 0, 0.3)';
         }
         return false;
      }

      // Validate mobile number (exactly 10 digits)
      if (mobile.length !== 10) {
         if (mobileField) {
            mobileField.focus();
            mobileField.style.borderColor = 'red';
            mobileField.style.boxShadow = '0 0 0 2px rgba(255, 0, 0, 0.3)';
         }
         return false;
      }

      if (!firstName) {
         if (firstNameField) {
            firstNameField.focus();
            firstNameField.style.borderColor = 'red';
            firstNameField.style.boxShadow = '0 0 0 2px rgba(255, 0, 0, 0.3)';
         }
         return false;
      }

      if (!lastName) {
         if (lastNameField) {
            lastNameField.focus();
            lastNameField.style.borderColor = 'red';
            lastNameField.style.boxShadow = '0 0 0 2px rgba(255, 0, 0, 0.3)';
         }
         return false;
      }

      if (!idNumber) {
         if (idField) {
            idField.focus();
            idField.style.borderColor = 'red';
            idField.style.boxShadow = '0 0 0 2px rgba(255, 0, 0, 0.3)';
         }
         return false;
      }

      return true;
   };

   const getPaymentLabel = (method) =>
      languageData?.[method?.name]?.[webSettingData?.language] ??
      method?.title ??
      method?.name?.replace(/_/g, ' ');

   const initPayPal = {
      'client-id': payPalClientId,
      currency: 'USD',
      intent: 'capture',
   };

   return (
      <>
         <PaymentAndButton>
            {paymentStutas === 'Pay Now' && (
               <>
                  {(() => {
                     const email = passengerInformation?.login_email || '';

                     // Only show an error when the email is non-empty and invalid.
                     if (!email || validateEmail(email)) {
                        const emailError =
                           document.getElementById('email-error');
                        if (emailError) {
                           emailError.innerHTML = '';
                        }
                        return (
                           <ButtonWrapper>
                              <CancelButton onClick={handleCancel}>
                                 {
                                    languageData?.checkout_page_cancel_btn[
                                       webSettingData?.language
                                    ]
                                 }
                              </CancelButton>
                              <div
                                 style={{
                                    marginTop: '10px',
                                    marginBottom: '10px',
                                    fontWeight: 600,
                                 }}
                              >
                                 Mpesa (Pay Now)
                              </div>
                              <Mpesa
                                 passengerInformation={passengerInformation}
                                 allBookingInformation={allBookingInformation}
                                 setLoading={setLoading}
                                 validateForm={validateForm}
                              />
                           </ButtonWrapper>
                        );
                     }

                     const emailError =
                        document.getElementById('email-error');
                     if (emailError) {
                        emailError.innerHTML = 'email is not valid';
                     }
                  })()}
               </>
            )}
         </PaymentAndButton>
      </>
   );
};

export default Payment;
